import { useEffect } from "react";

export function useTrackVisit(pageType: string, targetId?: string) {
	useEffect(() => {
		fetch(`${process.env.NEXT_PUBLIC_API_URL}/public/track/visit`, {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({ pageType, targetId }),
			keepalive: true,
		}).catch(() => {});
	}, [pageType, targetId]);
}
